// @flow
import type { Action, Environment } from '../types';

export type State = Environment;

export default function environment(state: State = {}, action: Action): State {
    switch(action.type) {
        default:
            return state;
    }
}